'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidFavoriteOutline = function IoAndroidFavoriteOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.1 5c5 0 8.9 3.9 8.9 9 0 6.2-5.5 11.2-13.9 18.9l-2.3 2.1-2.4-2.1c-8.4-7.7-13.9-12.7-13.9-18.9 0-5.1 3.9-9 8.9-9 2.8 0 5.6 1.3 7.4 3.4 1.7-2.1 4.5-3.4 7.3-3.4z m-6.3 25.7c3.9-3.6 7.3-6.7 9.6-9.5 2.2-2.8 3.1-4.9 3.1-7.2 0-1.8-0.7-3.5-1.9-4.6s-2.7-1.9-4.5-1.9c-2 0-4.1 1-5.5 2.6l-1.8 2.2-1.9-2.2c-1.4-1.6-3.5-2.6-5.5-2.6-1.8 0-3.4 0.7-4.5 1.9s-1.9 2.8-1.9 4.6c0 2.3 0.9 4.4 3.1 7.2 2.3 2.8 5.7 5.9 9.6 9.5l0.3 0.3 0.8 0.6 0.7-0.6z' })
        )
    );
};

exports.default = IoAndroidFavoriteOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-favorite-outline.js
// module id = 1888
// module chunks = 0